export default "<ng-template appGenericContentDirective></ng-template>";